import React from 'react';
import { iconeDaRotina } from '../constants/iconesRotinas';

// ════════════════════════════════════════════════════════════════════════════
// BrowseHeader.jsx — r105
// ────────────────────────────────────────────────────────────────────────────
// Padronização do cabeçalho das telas de browse do portal.
//
// Renderiza:
//   [ÍCONE SVG] Título grande
//                Descrição em texto secundário
//
// Uso típico (na tela do browse):
//
//   <BrowseHeader
//     rotina="acessos"
//     titulo="Acessos"
//     descricao="Credenciais de acesso aos ambientes dos clientes por colaborador."
//   />
//
// O ícone vem automaticamente de `iconesRotinas.jsx` (mesmo do menu lateral),
// na cor azul oficial #003399. Pode ser sobrescrito via prop `icone`.
// ════════════════════════════════════════════════════════════════════════════

const COR_AZUL = '#003399';
const COR_TEXTO = '#1a1a2e';
const COR_MUTED = '#888';

function BrowseHeader({
  rotina,
  titulo,
  descricao,
  icone,        // opcional: passa um JSX customizado em vez de usar a rotina
  tamIcone = 47,   // r108: aumentado +30% (de 36 → 47) a pedido do usuário
}) {
  // Resolve o ícone — prioriza prop custom, senão busca pela rotina
  const iconeRender = icone || (rotina
    ? iconeDaRotina(rotina, { width: tamIcone, height: tamIcone, color: COR_AZUL })
    : null);

  return (
    <div style={{
      // r107: alignItems center pra ícone (maior) ficar alinhado verticalmente
      //       com o centro do bloco título+descrição
      display: 'flex', alignItems: 'center', gap: '14px',
      marginBottom: '14px',
    }}>
      {iconeRender && (
        <div style={{
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          flexShrink: 0,
        }}>
          {iconeRender}
        </div>
      )}
      <div>
        <h2 style={{
          margin: 0, fontSize: '22px', fontWeight: '700',
          color: COR_TEXTO, lineHeight: '1.2',
        }}>
          {titulo}
        </h2>
        {descricao && (
          <div style={{
            fontSize: '13px', color: COR_MUTED, marginTop: '4px',
          }}>
            {descricao}
          </div>
        )}
      </div>
    </div>
  );
}

export default BrowseHeader;
